class StaticBundleLists extends HTMLElement {
  constructor() {
    super();
    this.lists = Array.from(this.querySelectorAll('.static-bundle-list'));
    this.productForm = document.querySelector('product-form form[action="/cart/add"]');
  }

  connectedCallback() {
    const idInput = document.querySelector('[data-element="id-input"]');
    //
    this.indexInput = this.createInput('number', 'properties[_static_bundle_custom_text_index]');
    this.productForm.appendChild(this.indexInput);
    //
    if (idInput) {
      const mutationCallback = (mutationList) => {
        for (const mutation of mutationList) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
            // console.log("kj mutationCallback", mutation.target.value, mutation.oldvalue);
            this.dataset.variant = mutation.target.value;
          }
        }
      };
      this.observer = new MutationObserver(mutationCallback);
      this.observer.observe(idInput, { attributes: true });
    }
  }

  disconnectedCallback() {
    this.observer.disconnect();
    this.observer = null;
  }

  static get observedAttributes() {
    return ['data-variant'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    console.log("kj attributeChangedCallback - newValue", newValue);
    if (name === 'data-variant' && oldValue !== newValue) {
      setTimeout(() => {
        this.variant = newValue;
        this.lists.forEach(l => l.dataset.show = false);
        const current = this.lists.find(l => l.dataset.id === this.variant);
        if (current) {
          current.dataset.show = true;
          /* Array.from(current.childNodes).forEach(el => console.log(el)); */
          const index = Array.from(current.querySelectorAll('.static-bundle-list__item')).findIndex(el => el.dataset?.type === 'Name Tag');
          this.indexInput.value = index === -1 ? 0 : index;
        } 
      }, 0);
    }
  }

  createInput(type, name) {
    const input = document.createElement('INPUT');
    input.hidden = true;
    input.type = type;
    input.name = name;
    return input;
  }


}

customElements.define('static-bundle-lists', StaticBundleLists);